export const api = 'https://api.barcelonabridalweek.com/v1/graphql'  

import axios from 'axios'
axios.defaults.headers.common['x-hasura-admin-secret'] = 'gHHdxsykQrqZc6rF'
//'Authorization': 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNvcG9ydGUuY2xpZW50ZXNAZmlyYWJhcmNlbG9uYS5jb20iLCJpZCI6NDQsImV4aGliaXRvcl9pZCI6bnVsbCwicm9sZSI6Imdyb3VwMCIsInNkYSI6dHJ1ZSwiYWNjb3VudF9pZCI6MzgsImJyYW5kX2lkIjpudWxsLCJpYXQiOjE2MDAxMDk1NTEsImV4cCI6MTYwMjcwMTU1MX0.Irl2ycpyg7cOwJ6nKhG1PVyCEIJL-93anaNQTR4fmls'

const queries = {

  createUser: ` 
    mutation MyMutation($age: String = "", $country: String = "", $gender: String = "", $id: String = "", $role: String = "") {
        openLogin(id: $id, gender: $gender, country: $country, age: $age, role: $role) {
          accessToken
        }
    }
  `,
  getUserId:`
    query MyQuery($email: String!) {
      users(where: {email: {_eq: $email}}) {
        id
        email
      }
    }
  `,
  getInteraction:`query MyQuery($id: Int!,$brandId: Int!) {
		interactions_actions_by_pk(id: $id) {
			id
			action
		}
		brands_by_pk(id: $brandId){
			name
		}
	}
  `,
  insertCrushData: `mutation MyMutation($object: interactions_crush_insert_input!) {
    insert_interactions_crush_one(object: $object) {
      id
    }
  } `,
  insertOOData: `mutation MyMutation($object: interactions_one_only_insert_input!) {
    insert_interactions_one_only_one(object: $object) {
      id
    }
  } `
}

export async function openLogin( id, gender, age, country){
	let response = {}
    console.log( id, gender, age, country)
	response = await axios.post(api,{
		query: queries.createUser,
		variables:{
			id: id,
            gender: gender,
            age: age,
            country: country,
            role:'brides_to_be'

		}
	})

	console.log("openLogin",response)

	return response.data.data
}

export async function getUserId( emailId){
	let response = {}    
	response = await axios.post(api,{
		query: queries.getUserId,
		variables:{
			email: emailId,
		}
	})

	console.log("getUserId",response)

	return response.data.data
}

export async function getData( actionId, brand_id){
	let response = {}    
	response = await axios.post(api,{
		query: queries.getInteraction,
		variables:{
			id: actionId,
			brandId: brand_id
		}
	})

	console.log("getData",response)

	return response.data.data
}

export async function sendCrushData( result ){
	let response = {}    
	response = await axios.post(api,{
		query: queries.insertCrushData,
		variables:{
			object: result,
		}
	})

	console.log("insertCrushData",response)

	return response.data.data
}

export async function sendOOData( result ){
	let response = {}    
	response = await axios.post(api,{
		query: queries.insertOOData,
		variables:{
			object: result,
		}
	})

	console.log("insertOOData",response)

	return response.data.data
}